const initialState = { requestedCourses: null };

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_COURSES":
      return {
        ...state,
        requestedCourses: action.data,
      };

    case "CREATE_COURSE": {
      let dt = state.requestedCourses.concat(action.data);
      return {
        ...state,
        requestedCourses: dt,
      };
    }
    case "UPDATE_COURSE": {
      let dt = state.requestedCourses.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        requestedCourses: dt,
      };
    }
    case "DELETE_COURSE": {
      let dt = state.requestedCourses.filter((a) => a._id !== action.data);
      return {
        ...state,
        requestedCourses: dt,
      };
    }
    default:
      return state;
  }
};

export default courseReducer;
